// extracted by mini-css-extract-plugin
export default {"QuizResultButton":"quizResultButton_QuizResultButton__VLMuq","spread":"quizResultButton_spread__rRiRY"};